<template>
  <div>
    <div 
      class="drawer-overlay" 
      :class="{ 'is-visible': visible }"
    >
      <div class="drawer-wrapper">
        <div class="drawer-header">
          <slot name="title"><span class="drawer-title">{{ title }}</span></slot>
          <span class="drawer-close" @click="handleClose">&times;</span>
        </div>
        <div class="drawer-body">
          <slot></slot>
        </div>
        <div class="drawer-footer" v-if="$slots.footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Drawer',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.drawer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0);
  z-index: 1000;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  padding: 112px 0 0 236px;
  box-sizing: border-box;
  pointer-events: none;
  transition: background-color 0.3s ease;
}

.drawer-overlay.is-visible {
  background-color: rgba(0, 0, 0, 0.5);
  pointer-events: auto;
}

.drawer-wrapper {
  width: 60%;
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
  transform: translateX(100%);
  transition: transform 0.3s ease;
}

.drawer-overlay.is-visible .drawer-wrapper {
  transform: translateX(0);
}

.drawer-header {
  position: relative;
  height: 48px;
  padding: 0 24px;
  background-color: #F2F3F5;
  border-bottom: 1px solid #e8e8e8;
  font-size: 16px;
  font-weight: 600;
  box-sizing: border-box;
  line-height: 48px;
}

.drawer-header::after {
  content: "";
  display: inline-block;
  width: 100%;
}

.drawer-close {
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 24px;
  cursor: pointer;
  color: #999;
  line-height: 1;
}

.drawer-close:hover {
  color: #333;
}

.drawer-body {
  flex: 1;
  padding: 24px;
  overflow-y: auto;
  box-sizing: border-box;
}

.drawer-footer {
  padding: 16px 24px;
  border-top: 1px solid #e8e8e8;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
</style>